/* eslint-disable react-hooks/rules-of-hooks */
import {
  Box,
  Center,
  Heading,
  Text,
  Stack,
  Avatar,
  useColorModeValue,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import Logo from "../../assets/gadget.svg";
export default function CardWithImg({ data }: any) {
  return (
    <Div>
      <Center py={6}>
        <Box
          maxW={"445px"}
          w={"full"}
          bg={useColorModeValue("white", "gray.900")}
          boxShadow={"2xl"}
          rounded={"md"}
          p={6}
          overflow={"hidden"}
          className="card-con"
        >
          <Box
            h={"210px"}
            bg={"gray.100"}
            mt={-6}
            mx={-6}
            mb={6}
            pos={"relative"}
            overflow={"hidden"}
          >
            <img className="img-card" src={data.image} />
          </Box>
          <Stack>
            <Text
              color={"green.500"}
              textTransform={"uppercase"}
              fontWeight={800}
              fontSize={"sm"}
              letterSpacing={1.1}
            >
              Blog
            </Text>
            <Heading
              color={useColorModeValue("gray.700", "white")}
              fontSize={"2xl"}
              fontFamily={"body"}
              className="blog-text"
            >
              <Link to={`/blog/${data.id}`}>{data.title}</Link>
            </Heading>
            <Text color={"gray.500"}>{data.shortDec}</Text>
          </Stack>
          <Stack mt={6} direction={"row"} spacing={4} align={"center"}>
            <Avatar src={Logo} />
            <Stack direction={"column"} spacing={0} fontSize={"sm"}>
              <Text fontWeight={600}>Gadgeting Team</Text>
              <Text color={"gray.500"}>
                {data.createdAt.toDate().toDateString()}
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Center>
    </Div>
  );
}

const Div = styled.div`
.blog-text :hover{
  color: #ff5733;
}
`;
